const routes = {
  searchBuyer: '/',
  buyerCard: '/ficha/informacion-general/:rut'
}

export default routes
